import React from 'react';
import '../template-file-css/document-file-template.css';


export const KE_AddictionSeverityIndex = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='KE_AddictionSeverityIndex' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Addiction Severity Index</h3></center></p>

                <p className='w-750'><b>GENERAL INFORMATION</b></p>

                <table>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'><b>G1.</b> Client Name</span> </td>
                        <td className='w-200'> <span className='eleHeader'><b>G4.</b> Date of Admission</span> </td>
                        <td className='w-200'> <span className='eleHeader'><b>G5.</b> Date of Interview</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfAdmission' name='txtDateOfAdmission' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfInterview' name='txtDateOfInterview' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'><b>G6.</b> Time Begun</span>
                        <span className='small'>Use 24 hr clock; code hours:minutes</span> </td>
                        <td className='w-250'> <span className='eleHeader'><b>G7.</b> Time Ended</span>
                        <span className='small'>Use 24 hr clock; code hours:minutes</span>
                         </td>
                        <td className='w-250'> <span className='eleHeader'><b>G8.</b> Class</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='time' id='txtTimeBegun' name='txtTimeBegun' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-250'>
                            <input type='radio' id='rbClass_Intake' name='rbClass' className='add-only' value='Intake' /> Intake &nbsp;
                            <input type='radio' id='rbClass_FollowUp' name='rbClass' className='add-only' value='Follow-up' /> Follow-up </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'><b>G9.</b> Contact Code</span> </td>
                        <td className='w-250'> <span className='eleHeader'><b>G10.</b> Gender</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='rbContactCode_InPerson' name='rbContactCode_InPerson' className='add-only' value='In person' /> In person &nbsp;
                            <input type='checkbox' id='rbContactCode_Telephone' name='rbContactCode_Telephone' className='add-only' value='Telephone' /> Telephone (Intake ASI must be in person) </td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'><b>G99.</b> Treatment Episode Number</span> </td>
                        <td className='w-375'> <span className='eleHeader'><b>G11.</b> Interviewer Code Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTreatmentNumber' name='txtTreatmentNumber' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInterviewerNumber' name='txtInterviewerNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'><b>G12.</b> Special</span>
                    <input type='radio' id='rbSpecial_Terminated' name='rbSpecial' className='add-only' value='Patient terminated' /> Patient terminated &nbsp;
                    <input type='radio' id='rbSpecial_Refused' name='rbSpecial' className='add-only' value='Patient refused' /> Patient refused &nbsp;
                    <input type='radio' id='rbSpecial_Respond' name='rbSpecial' className='add-only' value='Patient unable to respond' /> Patient unable to respond
                </p>

                <p className='w-750'> <span className='eleHeader'><b>G14.</b> How long have you lived at your current address?</span> </p>

                <p className='w-300'> <input type='text' id='txtCurrentAddressYrs' name='txtCurrentAddressYrs' placeholder='YRS' className='add-only w-100 custom-add-only' /> / <input type='text' id='txtCurrentAddressMos' name='txtCurrentAddressMos' placeholder='MOS' className='add-only w-100 custom-add-only' /></p>

                <table>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'><b>G15.</b> Is this residence owned by you or your family?</span> </td>
                        <td className='w-250'> <span className='eleHeader'><b>G16.</b> Date of birth</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='radio' id='rbResidence_Yes' name='rbResidence' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResidence_No' name='rbResidence' className='add-only' value='No' /> No</td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'><b>G17.</b> Of what race do you consider yourself?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_White' name='rbRace' className='add-only' value='White' /> White (not Hisp) </td>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_Black' name='rbRace' className='add-only' value='Black' /> Black (not Hisp) </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_AmericanIndian' name='rbRace' className='add-only' value='American Indian' /> American Indian </td>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_AlaskanNative' name='rbRace' className='add-only' value='Alaskan Native' /> Alaskan Native
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_AsianPacific' name='rbRace' className='add-only' value='Asian/Pacific' /> Asian/Pacific </td>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_HispanicMexican' name='rbRace' className='add-only' value='Hispanic-Mexican' /> Hispanic-Mexican
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_Hispanic' name='rbRace' className='add-only' value='Hispanic-Puerto' /> Hispanic-Puerto Rican </td>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_Cuban' name='rbRace' className='add-only' value='Hispanic-Cuban' /> Hispanic-Cuban
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRace_Unknown' name='rbRace' className='add-only' value='Unknown' /> Unknown </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'><b>G18.</b> Do you have a religious preference?</span></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbReligiousPreference_Protestant' name='rbReligiousPreference' className='add-only' value='Protestant' /> Protestant </td>
                        <td className='w-250'>
                            <input type='radio' id='rbReligiousPreference_Catholic' name='rbReligiousPreference' className='add-only' value='Catholic' /> Catholic
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbReligiousPreference_Jewish' name='rbReligiousPreference' className='add-only' value='Jewish' /> Jewish </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbReligiousPreference_Islamic' name='rbReligiousPreference' className='add-only' value='Islamic' /> Islamic
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbReligiousPreference_None' name='rbReligiousPreference' className='add-only' value='None' /> None </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbReligiousPreference_Other' name='rbReligiousPreference' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtReligiousPreferenceOther' name='txtReligiousPreferenceOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'><b>G19.</b> Have you been in a controlled environment in the past 30 days? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbControlled_No' name='rbControlled' className='add-only' value='No' /> No </td>
                        <td className='w-250'>
                            <input type='radio' id='rbControlled_Jail' name='rbControlled' className='add-only' value='Jail/prison' /> Jail/prison
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbControlled_Alcohol' name='rbControlled' className='add-only' value='Alcohol' /> Alcohol or drug tx </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbControlled_Medical' name='rbControlled' className='add-only' value='Medical tx' /> Medical tx
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbControlled_Psychiatric' name='rbControlled' className='add-only' value='Psychiatric tx' /> Psychiatric tx </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbControlled_Other' name='rbControlled' className='add-only' value='Other' /> Other (A place, theoretically, without access to drugs/alcohol.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtControlledOther' name='txtControlledOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'><b>G20.</b> How many days?</span>
                    <span className='small'>If G19 is No, code -8. <br />
                        Refers to total number of days detained in the past 30 days.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtHowManyDays' name='txtHowManyDays' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'>GENERAL INFORMATION COMMENTS</span>
                    <span className='small'> (Include the question number with your notes)</span>
                    <textarea id='txtGeneralInformation' name='txtGeneralInformation' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>MEDICAL STATUS</h4></center></p>

                <p className='w-750'> <span className='eleHeader'><b>M1.</b> How many times in your life have you been hospitalized for medical problems?</span>
                    <span className='small'>{`Include O.D.’s and D.T.’s. Exclude detox, alcohol/drug, psychiatric treatment and childbirth (if no complications). Enter the number of overnight hospitalizations for medical problems.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtHospitalized' name='txtHospitalized' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M2.</b> How long ago was your last hospitalization for a physical problem?</span>
                    <span className='small'>If no hospitalizations in Question M1, then code -8 / -8.</span>
                </p>

                <p className='w-300'> <input type='text' id='txtPhysicalProblemYrs' name='txtPhysicalProblemYrs' placeholder='YRS' className='add-only w-100 custom-add-only' /> / <input type='text' id='txtPhysicalProblemMos' name='txtPhysicalProblemMos' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M3.</b> Do you have any chronic medical problems which
                    continue to interfere with your life? </span>
                    <input type='radio' id='rbChronicMedicalProblems_Yes' name='rbChronicMedicalProblems' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbChronicMedicalProblems_No' name='rbChronicMedicalProblems' className='add-only' value='NO' /> NO </p>

                    <p className='w-750'><b> If Yes, specify in comments.</b>
                <span className='small'>{`A chronic medical condition is a serious physical condition that requires regular care (i.e., medication, dietary restriction) preventing full advantage of their abilities.`}</span>
                </p>

                <p className='w-750'><input type='text' id='txtChronicMedicalProblems' name='txtChronicMedicalProblems' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'><b>M4.</b> Are you taking any prescribed medication on a regular basis for a physical problem? </span>
                    <input type='radio' id='rbPrescribedMedication_Yes' name='rbPrescribedMedication' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPrescribedMedication_No' name='rbPrescribedMedication' className='add-only' value='NO' /> NO </p>

                <p className='w-750'><b> If Yes, specify in comments.</b>
                <span className='small'>{`Medication prescribed by a MD for medical conditions; not psychiatric medicines. Include medicines prescribed whether or not the patient is currently taking them. The intent is to verify chronic medical problems.`}</span>
                </p>
                <p className='w-750'><input type='text' id='txtMedicationPrescribed' name='txtMedicationPrescribed' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M5.</b> Do you receive a pension for a physical disability?
                </span>
                    <input type='radio' id='rbPension_Yes' name='rbPension' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPension_No' name='rbPension' className='add-only' value='NO' /> NO </p>

                <p className='w-750'><b> If Yes, specify in comments.</b>
                <span className='small'>{`Include Workers’ compensation, exclude psychiatric disability.`}</span>
                </p>
                <p className='w-750'><input type='text' id='txtCompensation' name='txtCompensation' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M6.</b> How many days have you experienced medical problems in the past 30 days? </span>
                    <span className='small'>{`Include flu, colds, etc. Include serious ailments related to drugs/alcohol, which would continue even if the patient were abstinent (e.g., cirrhosis of liver, abscesses from needles, etc.).`}</span>
                </p>

                <p className='w-100'> <input type='text' id='txtPastDays' name='txtPastDays' className='add-only' />
                </p>

                <p className='w-750'><b>For Questions M7 & M8, ask patient to use the Patient Rating Scale</b></p>

                <p className='w-750'> <span className='eleHeader'><b>M7.</b> How troubled or bothered have you been by these medical problems in the past 30 days? </span>
                    <span className='small'>Restrict response to problem days in Question M6.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtPatientRatingScale' name='txtPatientRatingScale' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M8.</b> How important to you now is treatment for these medical problems? </span>
                    <span className='small'>If client is currently receiving medical treatment, refer to the need for additional medical treatment by the patient.</span>
                </p>

                <p className='w-100'> <input type='text' id='txtPatientRatingScale_1' name='txtPatientRatingScale_1' className='add-only' />
                </p>

                <p className='w-750'><center><h4>INTERVIEWER SEVERITY RATING</h4></center>
                </p>

                <p className='w-750'> <span className='eleHeader'><b>M9.</b> How would you rate the patient's need for medical treatment? </span>
                    <span className='small'>Refers to the patient's need for additional medical treatment.</span>
                </p>

                <p className='w-100'> <input type='text' id='txtPatientNeed' name='txtPatientNeed' className='add-only' />
                </p>

                <p className='w-750'><center><h3>CONFIDENCE RATINGS</h3></center></p>

                <p className='w-750'><b>Is the above information significantly distorted by:</b></p>

                <p className='w-750'><span className='eleHeader'><b>M10.</b>Patient's misrepresentation? </span>
                    <input type='radio' id='rbMisrepresentation_Yes' name='rbMisrepresentation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMisrepresentation_No' name='rbMisrepresentation' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'><b>M11.</b> Patient's inability to understand? </span>
                    <input type='radio' id='rbInability_Yes' name='rbInability' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInability_No' name='rbInability' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>MEDICAL COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtMedicalComments' name='txtMedicalComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>EMPLOYMENT/SUPPORT STATUS</h4></center></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E1.</b> Education completed </span>
                    <span className='small'>GED = 12 years, note in comments. Include formal education only.</span>
                </p>

                <p className='w-300'> <input type='text' id='txtEducationCompleted' name='txtEducationCompleted' placeholder='YRS' className='add-only w-100 custom-add-only' /> /<input type='text' id='txtEducationCompleted_1' name='txtEducationCompleted_1' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E2.</b> Training or technical education completed </span>
                    <span className='small'>{`Formal, organized training only. For military training, only include training that can be used in civilian life (i.e., electronics,  computers)`}</span>
                </p>

                <p className='w-100'> <input type='text' id='txtTechnicalEducation' name='txtTechnicalEducation' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>E3.</b> Do you have a profession, trade, or skill? </span>
                <span className='small'>Employable, transferable skill acquired through training.</span>
                    <input type='radio' id='rbTrade_Yes' name='rbTrade' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTrade_No' name='rbTrade' className='add-only' value='NO' /> NO </p>

                <p className='w-750'><b>If Yes, specify:</b>
                    <br />
                    <input type='text' id='txtEmployable' name='txtEmployable' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>E4.</b> Do you have a valid driver's license? </span>
                <span className='small'>Valid license; not suspended/revoked.</span>
                    <input type='radio' id='rbValidLicense_Yes' name='rbValidLicense' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbValidLicense_No' name='rbValidLicense' className='add-only' value='NO' /> NO </p>

                <p className='w-750'> <span className='eleHeader'><b>E5.</b> Do you have an automobile available for use? </span>
                    <input type='radio' id='rbAutomobile_Yes' name='rbAutomobile' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAutomobile_No' name='rbAutomobile' className='add-only' value='NO' /> NO </p>

                <p className='small w-750'>If answer to E4 is No, then E5 must be No.
                    Does not require ownership, only requires availability on a regular basis. </p>

                <p className='w-750'> <span className='eleHeader'><b>E6.</b> How long was your longest full-time job?</span>
                    <span className='small'>Full-time = 35+ hours weekly; does not necessarily mean most recent job. </span>
                </p>

                <p className='w-300'> <input type='text' id='txtLongestJob' name='txtLongestJob' placeholder='YRS' className='add-only w-100 custom-add-only' /> / <input type='text' id='txtLongestJob_1' name='txtLongestJob_1' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'><b>E7.</b> Usual (or last) occupation </span></p>

                <p className='w-750'><b>Specify</b>
                    <span className='small'>(add all the details from last 2 years.)</span>
                    <input type='text' id='txtSpecify' name='txtSpecify' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>E8.</b> Does someone contribute to your support in any way? </span>
                <span className='small'>{`Is patient receiving any regular support (i.e., cash, food, housing) from family/friend. Include spouse’s contribution; exclude support by an institution.`}</span>
                    <input type='radio' id='rbContribute_Yes' name='rbContribute' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbContribute_No' name='rbContribute' className='add-only' value='NO' /> NO </p>

                <p className='w-750'> <span className='eleHeader'><b>E9.</b> Does this support constitute the majority of your support? </span>
                    <input type='radio' id='rbMajority_Yes' name='rbMajority' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMajority_No' name='rbMajority' className='add-only' value='NO' /> NO </p>
                <p className='small w-750'>{`If E8 is No, then E9 is -8.`}</p>

                <p className='w-750'><span className='eleHeader'><b>E10.</b> Usual employment pattern, past 3 years? </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFullTime' name='cbFullTime' className='add-only' value='Full time' /> Full time (35+ hours) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPartTime' name='cbPartTime' className='add-only' value='Part time' /> Part time (regular hours)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIrregularHours' name='cbIrregularHours' className='add-only' value='Irregular Hours' /> Part time (irregular hours) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbStudent' name='cbStudent' className='add-only' value='Student' /> Student
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMilitaryService' name='cbMilitaryService' className='add-only' value='Military service' /> Military service </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRetired' name='cbRetired' className='add-only' value='Retired' /> Retired/disability
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnemployed' name='cbUnemployed' className='add-only' value='Unemployed' /> Unemployed </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbControlled' name='cbControlled' className='add-only' value='In controlled environment' /> In controlled environment
                        </td>
                    </tr>
                </table>

                <p className='w-750'> Answer should represent the majority of the last 3 years, not just the most recent selection. If there are equal times for more than one category, select that which best represents the current situation.
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E11.</b> How many days were you paid for working in the past 30 days? </span>
                    <span className='small'>Include "under-the-table" work, paid sick days and vacation.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtUnderTheTable' name='txtUnderTheTable' className='add-only' />
                </p>

                <p className='w-750'><b>For questions E12-E17:
                    <br />
                    How much money did you receive from the following sources in the past 30 days? </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E12.</b> Employment </span>
                    <span className='small'>{`Net or "take home" pay, include any "under the table" money.`}</span>
                </p>
                <p className='w-150'> <input type='text' id='txtEmployment' name='txtEmployment' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E13.</b> Unemployment compensation </span>
                </p>
                <p className='w-150'> <input type='text' id='txtUnemployment' name='txtUnemployment' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E14.</b> Welfare </span>
                    <span className='small'>Include food stamps, transportation money provided by an agency to go to and from treatment.</span>
                </p>
                <p className='w-150'> <input type='text' id='txtWelfare' name='txtWelfare' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E15.</b> Pension, benefits or social security</span>
                    <span className='small'>{`Include disability pensions, retirement, veteran's benefits, SSI & worker's compensation.`}</span>
                </p>
                <p className='w-150'> <input type='text' id='txtPension' name='txtPension' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E16.</b> Mate, family or friends</span>
                    <span className='small'>{`Money for personal expenses (i.e., clothing); include unreliable sources of income. Record cash payments only, include windfalls (unexpected), money from loans, legal gambling, inheritance, tax returns, etc.`}</span>
                </p>
                <p className='w-150'> <input type='text' id='txtMate' name='txtMate' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E17.</b> Illegal</span>
                    <span className='small'>{`Cash obtained from drug dealing, stealing, fencing stolen goods, illegal gambling, prostitution, etc. Do not attempt to convert drugs exchanged to a dollar value.`}</span>
                </p>
                <p className='w-150'> <input type='text' id='txtIllegal' name='txtIllegal' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E18.</b> How many people depend on you for the majority of their food, shelter, etc.? </span>
                    <span className='small'>{`Must be regularly depending on patient; do include alimony/child support, do not include the patient or self-supporting spouse, etc.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtShelter' name='txtShelter' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E19.</b> How many days have you experienced employment problems in the past 30? </span>
                    <span className='small'>{`Include inability to find work, if they are actively looking for work, or problems with present job in which that job is jeopardized.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtExperienced' name='txtExperienced' className='add-only' />
                </p>

                <p className='w-650'><b>For Questions E20 & E21, ask patient to use the Patient Rating Scale </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E20.</b> How troubled or bothered have you been by these employment problems in the past 30 days? </span>
                    <span className='small'>{`If the patient has been incarcerated or detained during the past 30 days, they cannot have employment problems. In that case, code -8.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtIncarceratedE20' name='txtIncarceratedE20' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E21.</b> How important to you now is counseling for these employment problems?</span>
                    <span className='small'>Stress help in finding or preparing a job, not giving them a job.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtStressHelp' name='txtStressHelp' className='add-only' />
                </p>

                <p className='w-650'><center><h4>INTERVIEWER SEVERITY RATING</h4></center> </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>E22.</b> How would you rate the patient's need for employment counseling?</span>
                </p>
                <p className='w-100'> <input type='text' id='txtCounselingE22' name='txtCounselingE22' className='add-only' />
                </p>

                <p className='w-650'><center><h4>CONFIDENCE RATINGS</h4></center>
                </p>

                <p className='w-650'><b>Is the above information significantly distorted by:</b>
                </p>

                <p className='w-750'> <span className='eleHeader'><b>E23.</b> Client's misrepresentation? </span>
                    <input type='radio' id='rbClientMisrepresentation_Yes' name='rbClientMisrepresentation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientMisrepresentation__No' name='rbClientMisrepresentation' className='add-only' value='NO' /> NO
                </p>

                <p className='w-750'> <span className='eleHeader'><b>E24.</b> Client's inability to understand? </span>
                    <input type='radio' id='rbClientInability_Yes' name='rbClientInability' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientInability__No' name='rbClientInability' className='add-only' value='NO' /> NO
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>EMPLOYMENT/SUPPORT COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtSupportComments' name='txtSupportComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>ALCOHOL/DRUGS</h4></center></p>

                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Route of Administration Types:</span> <b>1-</b>Oral &nbsp; <b>2-</b>Nasal &nbsp; <b>3-</b>Smoking &nbsp; <b>4-</b>Non-IV injection &nbsp; <b>5-</b>IV
                            <span className='small'>Note the usual or most recent route. For more than one route, choose the most severe. The routes are listed from least severe to most severe.</span></td>
                        <td className='w-100'> <span className='eleHeader'>A. Past 30 Days</span> </td>
                        <td className='w-100'> <span className='eleHeader'>B. Lifetime (Years)</span> </td>
                        <td className='w-100'> <span className='eleHeader'>C. Route of Admin</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D1.</b> </td>
                        <td className='w-400'> Alcohol (any use at all) </td>
                        <td className='w-100'> <input type='text' id='txtAlcoholD1' name='txtAlcoholD1' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtAlcoholD1_1' name='txtAlcoholD1_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtAlcoholD1_2' name='txtAlcoholD1_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D2.</b> </td>
                        <td className='w-400'> Alcohol (to intoxication)</td>
                        <td className='w-100'> <input type='text' id='txtIntoxication' name='txtIntoxication' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtIntoxication_1' name='txtIntoxication_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtIntoxication_2' name='txtIntoxication_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D3.</b> </td>
                        <td className='w-400'> Heroin </td>
                        <td className='w-100'> <input type='text' id='txtHeroin' name='txtHeroin' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtHeroin_1' name='txtHeroin_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtHeroin_2' name='txtHeroin_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D4.</b> </td>
                        <td className='w-400'> Methadone </td>
                        <td className='w-100'> <input type='text' id='txtMethadone' name='txtMethadone' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtMethadone_1' name='txtMethadone_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtMethadone_2' name='txtMethadone_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D5.</b> </td>
                        <td className='w-400'> Other Opiates/Analgesics </td>
                        <td className='w-100'> <input type='text' id='txtAnalgesics' name='txtAnalgesics' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtAnalgesics_1' name='txtAnalgesics_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtAnalgesics_2' name='txtAnalgesics_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D6.</b> </td>
                        <td className='w-400'> Barbiturates </td>
                        <td className='w-100'> <input type='text' id='txtBarbiturates' name='txtBarbiturates' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtBarbiturates_1' name='txtBarbiturates_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtBarbiturates_2' name='txtBarbiturates_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D7.</b> </td>
                        <td className='w-400'> Other Sedatives/Hypnotics/
                            Tranquilizers </td>
                        <td className='w-100'> <input type='text' id='txtTranquilizers' name='txtTranquilizers' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtTranquilizers_1' name='txtTranquilizers_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtTranquilizers_2' name='txtTranquilizers_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D8.</b> </td>
                        <td className='w-400'> Cocaine </td>
                        <td className='w-100'> <input type='text' id='txtCocaine' name='txtCocaine' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtCocaine_1' name='txtCocaine_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtCocaine_2' name='txtCocaine_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D9.</b> </td>
                        <td className='w-400'> Amphetamines </td>
                        <td className='w-100'> <input type='text' id='txtAmphetamines' name='txtAmphetamines' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtAmphetamines_1' name='txtAmphetamines_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtAmphetamines_2' name='txtAmphetamines_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D10.</b> </td>
                        <td className='w-400'> Cannabis </td>
                        <td className='w-100'> <input type='text' id='txtCannabis' name='txtCannabis' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtCannabis_1' name='txtCannabis_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtCannabis_2' name='txtCannabis_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D11.</b> </td>
                        <td className='w-400'> Hallucinogens </td>
                        <td className='w-100'> <input type='text' id='txtHallucinogens' name='txtHallucinogens' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtHallucinogens_1' name='txtHallucinogens_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtHallucinogens_2' name='txtHallucinogens_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D12.</b> </td>
                        <td className='w-400'> Inhalants </td>
                        <td className='w-100'> <input type='text' id='txtInhalants' name='txtInhalants' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtInhalants_1' name='txtInhalants_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtInhalants_2' name='txtInhalants_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>D13.</b> </td>
                        <td className='w-400'>More than one substance per day
                            <span className='small'>Including alcohol</span>
                        </td>
                        <td className='w-100'> <input type='text' id='txtOneSubstance' name='txtOneSubstance' className='add-only' /></td>
                        <td className='w-100'> <input type='text' id='txtOneSubstance_1' name='txtOneSubstance_1' className='add-only' /></td>
                        <td className='w-100'><input type='text' id='txtOneSubstance_2' name='txtOneSubstance_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'><b>D14.</b> According to the interviewer, which substance is/are
                    the major problem?</span>
                    <input type='text' id='txtMajorProblem' name='txtMajorProblem' className='add-only' /> </p>
                <p className='small w-750'>Interviewer should determine the major drug or drugs of abuse. Code the number next to the drug in questions D1-D12, or:
                    <br />
                    <b>00 =</b>no problem  &nbsp;
                    <b>15 =</b>alcohol & one or more drugs <br />
                    <b> 16 =</b>more than one drugs but no alcohol. &nbsp;
                    Ask patient when not clear.
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D15.</b> How long was your last period of voluntary abstinence from this major substance? </span>
                    <span className='small'>Last attempt of at least one month, not necessarily the longest. Periods of hospitalization/incarceration do not count. Periods of antabuse, methadone, or naltrexone use during abstinence do count. 00 = never abstinent </span>
                </p>
                <p className='w-150'><input type='text' id='txtIncarceration' name='txtIncarceration' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D16.</b> How many months ago did this abstinence end? </span>
                    <span className='small'>If D15 = 0, &nbsp; then D16 = -8, &nbsp; 00 = Still abstinent</span>
                </p>
                <p className='w-150'><input type='text' id='txtAbstinenceEnd' name='txtAbstinenceEnd' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D17.</b> How many times have you had Alcohol D.T.'s? Delirium Tremems (DTs): </span>
                    <span className='small'>Occur 24-48 hours after last drink,
                        or significant decrease in alcohol intake, shaking, severe disorientation, fever, hallucinations, they usually require medical attention.</span>
                </p>
                <p className='w-100'><input type='text' id='txtDelirium' name='txtDelirium' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D18.</b> How many times have you overdosed on drugs? Overdoses (OD): </span>
                    <span className='small'>Require requires intervention by someone to recover, not simply sleeping it off, include suicide attempts by OD.</span>
                </p>
                <p className='w-100'><input type='text' id='txtOverdosed' name='txtOverdosed' className='add-only' />
                </p>

                <p className='w-750'><b>How many times in your life have you been treated for:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D19.</b> Alcohol abuse?</span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholAbuse' name='txtAlcoholAbuse' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D20.</b> Drug abuse? </span>
                    <span className='small'>{`Include detoxification, halfway houses, in/outpatient counseling, and AA or NA (if 3+ meetings within one month period).`}</span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugAbuse' name='txtDrugAbuse' className='add-only' />
                </p>

                <p className='w-750'><b>How many of these were detox only? </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D21.</b> Alcohol?</span>
                    <span className='small'>{`If D19 = 0, then D21 = -8 `}</span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholD21' name='txtAlcoholD21' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D22.</b> Drugs?</span>
                    <span className='small'>{`If D20 = 0, then D22 = -8`}</span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugsD22' name='txtDrugsD22' className='add-only' />
                </p>

                <p className='w-750'><b>How much money would you say you spent during the past 30 days on: </b></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D23.</b> Alcohol?</span>
                </p>
                <p className='w-150'><input type='text' id='txtAlcoholD23' name='txtAlcoholD23' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D24.</b> Drugs?</span>
                    <span className='small'>Only count actual money spent. What is the financial burden caused by drugs/alcohol?</span>
                </p>
                <p className='w-150'><input type='text' id='txtDrugsD24' name='txtDrugsD24' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D25.</b> How many days have you been treated in an outpatient setting for alcohol or drugs in the past 30 days?</span>
                    <span className='small'>Include AA/NA </span>
                </p>
                <p className='w-100'><input type='text' id='txtOutpatientD25' name='txtOutpatientD25' className='add-only' />
                </p>

                <p className='w-750'><b>How many days in the past 30 have you experienced:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D26.</b> Alcohol problems? </span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholProblemsD26' name='txtAlcoholProblemsD26' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D27.</b> Drug problems?</span>
                    <span className='small'>Include craving, withdrawal symptoms, disturbing effects of use, or wanting to
                        stop and being unable to. </span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugProblemsD27' name='txtDrugProblemsD27' className='add-only' />
                </p>

                <p className='w-750'><b>For Questions D28 - D31, ask patient to use the Patient Rating Scale</b></p>

                <p className='w-750'><b>How troubled or bothered have you been in the past 30 days by these:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D28.</b> Alcohol problems </span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholProblemsD28' name='txtAlcoholProblemsD28' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D29.</b> Drug problems </span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugProblemsD29' name='txtDrugProblemsD29' className='add-only' />
                </p>

                <p className='w-750'><b>How important to you now is treatment for these:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D30.</b> Alcohol problems</span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholProblemsD30' name='txtAlcoholProblemsD30' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>D31.</b> Drug problems</span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugProblemsD31' name='txtDrugProblemsD31' className='add-only' />
                </p>

                <p className='w-750'><center><h4>INTERVIEWER SEVERITY RATING</h4></center></p>

                <p className='w-750'><b>How would you rate the patient's need for treatment for:</b></p>

                <p className='w-750'> <span className='eleHeader'><b>D32.</b> Alcohol problems </span>
                </p>
                <p className='w-100'><input type='text' id='txtAlcoholProblemsD32' name='txtAlcoholProblemsD32' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'><b>D33.</b> Drug problems </span>
                </p>
                <p className='w-100'><input type='text' id='txtDrugProblemsD33' name='txtDrugProblemsD33' className='add-only' />
                </p>

                <p className='w-750'><center><h4>CONFIDENCE RATINGS</h4></center></p>

                <p className='w-750'><b>Is the above information significantly distorted by:</b></p>

                <p className='w-750'> <span className='eleHeader'><b>D34.</b> Client's misrepresentation? </span>
                    <input type='radio' id='rbDistortedBy_Yes' name='rbDistortedBy' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDistortedBy_No' name='rbDistortedBy' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'><b>D35.</b> Client's inability to understand? </span>
                    <input type='radio' id='rbUnderstand_Yes' name='rbUnderstand' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbUnderstand_No' name='rbUnderstand' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>ALCOHOL/DRUG COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtDrugComments' name='txtDrugComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>LEGAL STATUS</h4></center></p>

                <p className='w-750'> <span className='eleHeader'><b>L1.</b> Was this admission prompted or suggested by the criminal justice system? </span>
                    <span className='small'>Judge, probation/parole officer, etc.</span>
                    <input type='radio' id='rbCriminalJustice_Yes' name='rbCriminalJustice' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCriminalJustice_No' name='rbCriminalJustice' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'><b>L2.</b> Are you on probation or parole? </span>
                    <span className='small'> Note duration and level in comments. </span>
                    <input type='radio' id='rbProbation_Yes' name='rbProbation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbProbation_No' name='rbProbation' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><b>How many times in your life have you been arrested and charged with the following?</b>
                </p>

                <p className='w-750'> <span className='eleHeader'><b>L3.</b> Shoplifting/Vandalism</span> </p>
                <p className='w-150'> <input type='text' id='txtShoplifting' name='txtShoplifting' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L4.</b> Parole/Probation Violations</span> </p>
                <p className='w-150'> <input type='text' id='txtParole' name='txtParole' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L5.</b> Drug Charges</span> </p>
                <p className='w-150'> <input type='text' id='txtDrugCharges' name='txtDrugCharges' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L6.</b> Forgery</span> </p>
                <p className='w-150'> <input type='text' id='txtForgery' name='txtForgery' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L7.</b> Weapons Offense</span> </p>
                <p className='w-150'> <input type='text' id='txtWeaponsOffense' name='txtWeaponsOffense' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L8.</b> Burglary/Larceny/Breaking & Entering</span> </p>
                <p className='w-150'> <input type='text' id='txtBurglary' name='txtBurglary' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L9.</b> Robbery</span> </p>
                <p className='w-150'> <input type='text' id='txtRobbery' name='txtRobbery' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L10.</b> Assault</span> </p>
                <p className='w-150'> <input type='text' id='txtAssault' name='txtAssault' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L11.</b> Arson</span> </p>
                <p className='w-150'> <input type='text' id='txtArson' name='txtArson' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L12.</b> Rape</span> </p>
                <p className='w-150'> <input type='text' id='txtRape' name='txtRape' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L13.</b> Homicide/Manslaughter</span> </p>
                <p className='w-150'> <input type='text' id='txtHomicide' name='txtHomicide' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L14.</b> Prostitution</span> </p>
                <p className='w-150'> <input type='text' id='txtProstitution' name='txtProstitution' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L15.</b> Contempt of Court</span> </p>
                <p className='w-150'> <input type='text' id='txtContemptOfCourt' name='txtContemptOfCourt' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L16.</b> Other:</span> </p>
                <p className='w-150'> <input type='text' id='txtOtherL16' name='txtOtherL16' className='add-only' /> </p>

                <p className='w-750'> <input type='text' id='txtOther' name='txtOther' placeholder='Explain Other' className='add-only' /> </p>


                <p className='small w-750'>Include total number of counts, not just convictions.
                    <br />
                    Do not include juvenile (pre-age 18) crimes, unless they were tried as an adult. Include formal charges only.
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L17.</b> How many of these charges resulted in convictions?</span>
                    <span className='small'>If L3-16 = 00, then Question L17 = -8 <br />
                        Do not include misdemeanor offenses from questions L18-20 below.
                        <br />
                        Convictions include fines, probation, incarcerations, suspended sentences, guilty please, and plea bargaining.</span>
                </p>
                <p className='w-150'> <input type='text' id='txtConvictions' name='txtConvictions' className='add-only' /> </p>

                <p className='w-750'><b>How many times in your life have you been charged with the following:</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L18.</b> Disorderly conduct, vagrancy, public intoxication </span>
                </p>
                <p className='w-200'> <input type='text' id='txtVagrancy' name='txtVagrancy' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L19.</b> Driving while intoxicated </span>
                </p>
                <p className='w-150'> <input type='text' id='txtIntoxicated' name='txtIntoxicated' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L20.</b> Major driving violations </span>
                    <span className='small'>Moving violations: speeding, reckless driving, no license, etc.</span>
                </p>
                <p className='w-150'> <input type='text' id='txtViolations' name='txtViolations' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L21.</b> How many months were you incarcerated in your life? </span>
                    <span className='small'>If incarcerated 2 weeks or more, round this up to 1 month. List total number of months incarcerated.</span>
                </p>
                <p className='w-150'> <input type='text' id='txtIncarceratedL21' name='txtIncarceratedL21' placeholder='MOS' className='add-only w-100 custom-add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L22.</b> How long was your last incarceration? </span>
                    <span className='small'>Of 2 weeks or more. Code -8 if never incarcerated.</span>
                </p>
                <p className='w-150'> <input type='text' id='txtLastIncarcerated' name='txtLastIncarcerated' placeholder='MOS' className='add-only w-100 custom-add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L23.</b> What was it for? </span>
                    <span className='small'>{`Use codes 03–16, 18–20 If multiple charges, code most severe.Code -8 if never incarcerated.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtMultipleCharges' name='txtMultipleCharges' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>L24.</b> Are you presently awaiting charges, trial, or sentence?</span>
                    <input type='radio' id='rbTrial_Yes' name='rbTrial' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTrial_No' name='rbTrial' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L25.</b> What for? </span>
                    <span className='small'>{`Refers to Question L24. Use the number of the type of crime committed: 03-16 and 18-20. If multiple charges, code most severe.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtCrimeCommitted' name='txtCrimeCommitted' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L26.</b> How many days in the past 30 were you detained or incarcerated?</span>
                    <span className='small'>Include being arrested and released on the same day.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtBeingArrested' name='txtBeingArrested' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L27.</b> How many days in the past 30 have you engaged in illegal activities for profit? </span>
                    <span className='small'>Exclude simple drug possession. Include drug dealing, prostitution, selling stolen goods, etc. May be cross-checked with E17 under Employment section.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtIllegalActivities' name='txtIllegalActivities' className='add-only' />
                </p>

                <p className='w-750'><b>For Questions L28 & L29, ask patient to use the Patient Rating Scale</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L28.</b> How serious do you feel your present legal problems are? </span>
                    <span className='small'>Exclude civil problems.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtLegalProblemsL28' name='txtLegalProblemsL28' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L29.</b> How important to you now is counseling or referral for these legal problems? </span>
                    <span className='small'>Patient is rating a need for additional referral to legal counsel for defense against criminal charges.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtCounselingL29' name='txtCounselingL29' className='add-only' />
                </p>

                <p className='w-750'><center><h4>INTERVIEWER SEVERITY RATING</h4></center></p>

                <p className='w-750'>
                    <span className='eleHeader'><b>L30.</b> How would you rate the patient's need for legal services or counseling? </span>
                </p>
                <p className='w-100'> <input type='text' id='txtLegalProblemsL30' name='txtLegalProblemsL30' className='add-only' /> </p>

                <p className='w-750'><center><h4>CONFIDENCE RATINGS</h4></center></p>

                <p className='w-750'><b>Is the above information significantly distorted by:</b></p>

                <p className='w-750'> <span className='eleHeader'><b>L31.</b> Client's misrepresentation? </span>
                    <input type='radio' id='rbMisrepresentationL31_Yes' name='rbMisrepresentationL31' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMisrepresentationL31_No' name='rbMisrepresentationL31' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'><b>L32.</b> Client's inability to understand? </span>
                    <input type='radio' id='rbClientInabilityL32_Yes' name='rbClientInabilityL32' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientInabilityL32_No' name='rbClientInabilityL32' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>LEGAL COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtLegalComments' name='txtLegalComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>FAMILY HISTORY</h4></center></p>

                <p className='w-750'><b>Have any of your blood-related relatives had what you would call a significant drinking, drug use or psychiatric problem?
                    Specifically, was there a problem that did or should have led to treatment? </b></p>

                <p className='w-750'><b>0-</b>Clearly NO for all relatives in the category
                    <br />
                    <b>1-</b>Clearly YES for any relative within category
                    <br />
                    <b>-9-</b>Uncertain or don't know
                    <br />
                    <b>-8-</b>Never was a relative
                </p>

                <p className='small w-750'>{`In cases where there is more than one person for a category, record the occurrence of problems for any in that group. Accept the patient’s judgment on these questions.`}</p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Mother's Side</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Alc</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Drug</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Psych</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H1.</b></td>
                        <td className='w-400'>Grandmother</td>
                        <td className='w-100'> <input type='text' id='txtAlc' name='txtAlc' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug' name='txtDrug' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych' name='txtPsych' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H2.</b></td>
                        <td className='w-400'>Grandfather</td>
                        <td className='w-100'> <input type='text' id='txtAlc_1' name='txtAlc_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_1' name='txtDrug_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_1' name='txtPsych_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H3.</b></td>
                        <td className='w-400'>Mother</td>
                        <td className='w-100'> <input type='text' id='txtAlc_2' name='txtAlc_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_2' name='txtDrug_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_2' name='txtPsych_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H4.</b></td>
                        <td className='w-400'>Aunt</td>
                        <td className='w-100'> <input type='text' id='txtAlc_3' name='txtAlc_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_3' name='txtDrug_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_3' name='txtPsych_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H5.</b></td>
                        <td className='w-400'>Uncle</td>
                        <td className='w-100'> <input type='text' id='txtAlc_4' name='txtAlc_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_4' name='txtDrug_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_4' name='txtPsych_4' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Father's Side</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Alc</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Drug</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Psych</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H6.</b></td>
                        <td className='w-400'>Grandmother</td>
                        <td className='w-100'> <input type='text' id='txtAlc_5' name='txtAlc_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_5' name='txtDrug_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_5' name='txtPsych_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H7.</b></td>
                        <td className='w-400'>Grandfather</td>
                        <td className='w-100'> <input type='text' id='txtAlc_6' name='txtAlc_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_6' name='txtDrug_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_6' name='txtPsych_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H8.</b></td>
                        <td className='w-400'>Father</td>
                        <td className='w-100'> <input type='text' id='txtAlc_7' name='txtAlc_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_7' name='txtDrug_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_7' name='txtPsych_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H9.</b></td>
                        <td className='w-400'>Aunt</td>
                        <td className='w-100'> <input type='text' id='txtAlc_8' name='txtAlc_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_8' name='txtDrug_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_8' name='txtPsych_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H10.</b></td>
                        <td className='w-400'>Uncle</td>
                        <td className='w-100'> <input type='text' id='txtAlc_9' name='txtAlc_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_9' name='txtDrug_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_9' name='txtPsych_9' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Siblings</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Alc</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Drug</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Psych</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H11.</b></td>
                        <td className='w-400'>Brother</td>
                        <td className='w-100'> <input type='text' id='txtAlc_10' name='txtAlc_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_10' name='txtDrug_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_10' name='txtPsych_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>H12.</b></td>
                        <td className='w-400'>Sister</td>
                        <td className='w-100'> <input type='text' id='txtAlc_11' name='txtAlc_11' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDrug_11' name='txtDrug_11' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPsych_11' name='txtPsych_11' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>FAMILY HISTORY COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtFamilyHistory' name='txtFamilyHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>FAMILY/SOCIAL RELATIONSHIPS</h4></center></p>

                <p className='w-750'><span className='eleHeader'>F1. Marital Status</span></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Remarried' name='rbMaritalStatus' className='add-only' value='Remarried' /> Remarried </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Widowed' name='rbMaritalStatus' className='add-only' value='Widowed' /> Widowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Separated' name='rbMaritalStatus' className='add-only' value='Separated' /> Separated </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_NeverMarried' name='rbMaritalStatus' className='add-only' value='Never married' /> Never married
                        </td>
                    </tr>
                </table>

                <p className='small w-750'>Common-law marriage = 1. Specify in comments.</p>

                <p className='w-750'> <span className='eleHeader'><b>F2.</b> How long have you been in this marital status?</span>
                    <span className='small'> Refers to F1. If never married, then since age 18.</span>
                </p>
                <p className='w-300'> <input type='text' id='txtMaritalStatus' name='txtMaritalStatus' placeholder='YRS' className='add-only w-100 custom-add-only' /> / <input type='text' id='txtMaritalStatus_1' name='txtMaritalStatus_1' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>F3. Are you satisfied with this situation?</span>
                    <input type='radio' id='rbSatisfiedF3_No' name='rbSatisfiedF3' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbSatisfiedF3_Indifferent' name='rbSatisfiedF3' className='add-only' value='Indifferent' /> Indifferent &nbsp;
                    <input type='radio' id='rbSatisfiedF3_Yes' name='rbSatisfiedF3' className='add-only' value='Yes' /> Yes
                </p>

                <p className='small w-750'>Satisfied=client generally liking the situation. Refers to F1 and F2.</p>

                <p className='w-750'><span className='eleHeader'>F4. Usual living arrangements (past 3 years) </span></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Children' name='rbArrangements' className='add-only' value='With sexual partner & children' /> With sexual partner & children </td>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_SexualPartner' name='rbArrangements' className='add-only' value='With sexual partner alone' /> With sexual partner alone </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_AloneF4' name='rbArrangements' className='add-only' value='With children alone' /> With children alone </td>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Parents' name='rbArrangements' className='add-only' value='With parents' /> With parents </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Family' name='rbArrangements' className='add-only' value='With family' /> With family </td>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Friends' name='rbArrangements' className='add-only' value='With friends' /> With friends </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Alone' name='rbArrangements' className='add-only' value='Alone' /> Alone </td>
                        <td className='w-375'>
                            <input type='radio' id='rbArrangements_Controlled' name='rbArrangements' className='add-only' value='Controlled environment' /> Controlled environment </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbArrangements_Arrangement' name='rbArrangements' className='add-only' value='No stable arrangement' /> No stable arrangement </td>
                    </tr>
                </table>

                <p className='small w-750'>Choose arrangements most representative of the past 3 years. If there is an even split in time between these arrangements, choose the most recent arrangement. </p>

                <p className='w-750'> <span className='eleHeader'><b>F5.</b> How long have you lived in these arrangements?</span>
                    <span className='small'>If with parents or family, since age 18. Code years and months living in arrangements from F4. </span>
                </p>
                <p className='w-300'> <input type='text' id='txtArrangementsYrs' name='txtArrangementsYrs' placeholder='YRS' className='add-only w-100 custom-add-only' /> / <input type='text' id='txtArrangementsMos' name='txtArrangementsMos' placeholder='MOS' className='add-only w-100 custom-add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'><b>F6.</b> Are you satisfied with these arrangements? </span>
                    <input type='radio' id='rbArrangements_No' name='rbArrangements' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbArrangements_Indifferent' name='rbArrangements' className='add-only' value='Indifferent' /> Indifferent &nbsp;
                    <input type='radio' id='rbArrangements_Yes' name='rbArrangements' className='add-only' value='Yes' /> Yes
                </p>

                <p className='w-750'><b>Do you live with anyone who:</b></p>

                <p className='w-750'><span className='eleHeader'><b>F7.</b> Has a current alcohol problem? </span>
                    <input type='radio' id='rbAlcoholProblem_Yes' name='rbAlcoholProblem' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAlcoholProblem_No' name='rbAlcoholProblem' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'><b>F8.</b> Uses non-prescribed drugs?</span>
                <span className='small'>Or abuses prescribed drugs</span>
                    <input type='radio' id='rbPrescribedDrugs_Yes' name='rbPrescribedDrugs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPrescribedDrugs_No' name='rbPrescribedDrugs' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'><b>F9.</b> With whom do you spend most of your free time? </span>
                    <span className='small'>If a girlfriend/boyfriend is considered as family by patient, then they must refer to them as family throughout this section, not a friend.</span>
                    <input type='radio' id='rbFreeTime_Family' name='rbFreeTime' className='add-only' value='Family' /> Family &nbsp;
                    <input type='radio' id='rbFreeTime_Friends' name='rbFreeTime' className='add-only' value='Friends' /> Friends &nbsp;
                    <input type='radio' id='rbFreeTime_Alone' name='rbFreeTime' className='add-only' value='Alone' /> Alone
                </p>

                <p className='w-750'><span className='eleHeader'><b>F10.</b> Are you satisfied with spending your free time this way? </span>
                    <span className='small'>A satisfied response must indicate that the person generally likes the situation. Refers to F9. </span>
                    <input type='radio' id='rbSatisfied_No' name='rbSatisfied' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbSatisfied_Indifferent' name='rbSatisfied' className='add-only' value='Indifferent' /> Indifferent &nbsp;
                    <input type='radio' id='rbSatisfied_Yes' name='rbSatisfied' className='add-only' value='Yes' /> Yes
                </p>

                <p className='w-750'> <span className='eleHeader'><b>F11.</b> How many close friends do you have? </span>
                    <span className='small'>Stress that you mean close. <br />
                        Exclude family members. <br />
                        These are "reciprocal" relationships or mutually supportive relationships.</span></p>
                <p className='w-100'> <input type='text' id='txtCloseFriendsF11' name='txtCloseFriendsF11' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Would you say you have had a close reciprocal relationship with any of the following people: </span></p>

                <table>
                    <tr>
                        <td className='w-50'> <b>F12.</b> </td>
                        <td className='w-300'> Mother </td>
                        <td className='w-400'> <input type='text' id='txtMotherF12' name='txtMotherF12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F13.</b> </td>
                        <td className='w-300'> Father </td>
                        <td className='w-400'> <input type='text' id='txtFatherF13' name='txtFatherF13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F14.</b> </td>
                        <td className='w-300'> Brothers/Sisters </td>
                        <td className='w-400'> <input type='text' id='txtBrothersF14' name='txtBrothersF14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F15.</b> </td>
                        <td className='w-300'> Sexual Partner/Spouse </td>
                        <td className='w-400'> <input type='text' id='txtSpouseF15' name='txtSpouseF15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F16.</b> </td>
                        <td className='w-300'> Children </td>
                        <td className='w-400'> <input type='text' id='txtChildrenF16' name='txtChildrenF16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F17.</b> </td>
                        <td className='w-300'> Friends </td>
                        <td className='w-400'> <input type='text' id='txtFriendsF17' name='txtFriendsF17' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>0-</b> Clearly NO for all in class &nbsp; &nbsp; &nbsp; &nbsp;
                    <b>1-</b> Clearly YES for any in class

                    <br />

                    <b>-9-</b> Uncertain or "I don't know" &nbsp; &nbsp; &nbsp; &nbsp;
                    <b>-8-</b> Never was a relative </p>

                <p className='small w-750'>By reciprocal, you mean "that you would do anything you could to help them out and vice versa." </p>

                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>Have you had significant periods in which you have experienced
                            serious problems getting along with: </span>
                            <input type='radio' id='rbExperienced_Yes' name='rbExperienced' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbExperienced_No' name='rbExperienced' className='add-only' value='No' /> No</td>
                        <td className='w-100'><span className='eleHeader'>Past 30 Days </span> </td>
                        <td className='w-100'><span className='eleHeader'>In Your Life</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F18. </b> </td>
                        <td className='w-500'>Mother </td>
                        <td className='w-100'> <input type='text' id='txtMother' name='txtMother' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtMother_1' name='txtMother_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F19. </b> </td>
                        <td className='w-500'> Father </td>
                        <td className='w-100'> <input type='text' id='txtFather' name='txtFather' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFather_1' name='txtFather_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F20. </b> </td>
                        <td className='w-500'> Brothers/Sisters </td>
                        <td className='w-100'> <input type='text' id='txtSisters' name='txtSisters' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtSisters_1' name='txtSisters_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F21. </b> </td>
                        <td className='w-500'>Sexual Partner/Spouse </td>
                        <td className='w-100'> <input type='text' id='txtSpouse' name='txtSpouse' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtSpouse_1' name='txtSpouse_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F22. </b> </td>
                        <td className='w-500'> Children </td>
                        <td className='w-100'> <input type='text' id='txtChildren' name='txtChildren' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtChildren_1' name='txtChildren_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F23. </b> </td>
                        <td className='w-500'> Other significant family </td>
                        <td className='w-100'> <input type='text' id='txtSignificant' name='txtSignificant' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtSignificant_1' name='txtSignificant_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Specify:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSpecifyF23' name='txtSpecifyF23' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F24. </b> </td>
                        <td className='w-500'> Close Friends </td>
                        <td className='w-100'> <input type='text' id='txtCloseFriends' name='txtCloseFriends' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCloseFriends_1' name='txtCloseFriends_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F25. </b> </td>
                        <td className='w-500'> Neighbors </td>
                        <td className='w-100'> <input type='text' id='txtNeighbors' name='txtNeighbors' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtNeighbors_1' name='txtNeighbors_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F26. </b> </td>
                        <td className='w-500'> Co-Workers </td>
                        <td className='w-100'> <input type='text' id='txtCoWorkers' name='txtCoWorkers' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCoWorkers_1' name='txtCoWorkers_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='small w-750'>"Serious problems" mean those that endangered the relationship. <br />
                    A "problem" requires contact of some sort, either by telephone or in person.
                    <br />
                    If no contact, code -8. </p>

                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>Has anyone ever abused you? </span>
                            <input type='radio' id='rbAbusedYou_Yes' name='rbAbusedYou' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAbusedYou_No' name='rbAbusedYou' className='add-only' value='No' /> No </td>
                        <td className='w-100'><span className='eleHeader'>Past 30 Days </span> </td>
                        <td className='w-100'><span className='eleHeader'>In Your Life</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F27.</b> </td>
                        <td className='w-500'> Emotionally? <span className='small'>Make you feel bad through harsh words</span> </td>
                        <td className='w-100'> <input type='text' id='txtEmotionally' name='txtEmotionally' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtEmotionally_1' name='txtEmotionally_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F28.</b> </td>
                        <td className='w-500'> Physically? <span className='small'>Caused you physical harm</span> </td>
                        <td className='w-100'> <input type='text' id='txtPhysically' name='txtPhysically' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPhysically_1' name='txtPhysically_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>F29.</b> </td>
                        <td className='w-500'> Sexually? <span className='small'>Force sexual advances/acts </span> </td>
                        <td className='w-100'> <input type='text' id='txtSexually' name='txtSexually' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtSexually_1' name='txtSexually_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>How many days in the past 30 have you had serious conflicts:</b></p>

                <p className='w-750'><span className='eleHeader'><b>F30.</b>With your family? </span></p>
                <p className='w-100'> <input type='text' id='txtFamilyF30' name='txtFamilyF30' className='add-only' /> </p>

                <p className='w-750'><span className='eleHeader'><b>F31.</b>With other people?</span>
                    <span className='small'>(excluding family)</span>
                </p>
                <p className='w-100'> <input type='text' id='txtExcludingFamily' name='txtExcludingFamily' className='add-only' /> </p>

                <p className='w-750'><b>For Questions F32 - F35, ask patient to use the Patient Rating Scale</b></p>

                <p className='w-750'><b>How troubled or bothered have you been in the past 30 days by:</b></p>

                <p className='w-750'><span className='eleHeader'><b>F32.</b>Family problems</span>
                    <span className='small'>(excluding family)</span>
                </p>
                <p className='w-100'> <input type='text' id='txtFamilyProblemsF32' name='txtFamilyProblemsF32' className='add-only' /> </p>

                <p className='w-750'><span className='eleHeader'><b>F33.</b>Social problems</span>
                    <span className='small'>(excluding family)</span>
                </p>
                <p className='w-100'> <input type='text' id='txtSocialFamilyF33' name='txtSocialFamilyF33' className='add-only' />
                </p>

                <p className='w-750'><b>How important to you now is treatment or counseling for these:</b></p>

                <p className='w-750'><span className='eleHeader'><b>F34.</b>Family problems</span>
                    <span className='small'>Patient is rating his/her need for counseling for family problems, not whether they would be willing to attend.</span>
                </p>
                <p className='w-100'> <input type='text' id='txtFamilyProblemsF34' name='txtFamilyProblemsF34' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'><b>F35.</b>Social problem</span>
                    <span className='small'>{`Include patient's need to seek treatment for such social problems as loneliness, inability to socialize, and dissatisfaction with friends. Patient rating should refer to dissatisfaction, conflicts, or other serious problems.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtSocialFamilyF35' name='txtSocialFamilyF35' className='add-only' /> </p>

                <p className='w-750'><center><h4>INTERVIEWER SEVERITY RATING </h4></center></p>

                <p className='w-750'><span className='eleHeader'><b>F36.</b>How would you rate the patient's need for family and/ or social counseling? </span>
                </p>
                <p className='w-100'> <input type='text' id='txtSocialCounseling' name='txtSocialCounseling' className='add-only' /> </p>

                <p className='w-750'><center><h4>CONFIDENCE RATINGS</h4></center></p>

                <p className='w-750'><b>Is the above information significantly distorted by:</b></p>

                <p className='w-750'><span className='eleHeader'>F37. Client's misrepresentation?</span>
                    <input type='radio' id='rbClientMisrepresentationF37_Yes' name='rbClientMisrepresentationF37' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientMisrepresentationF37_No' name='rbClientMisrepresentationF37' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>F38. Client's inability to understand? </span>
                    <input type='radio' id='rbClientInabilityF38_Yes' name='rbClientInabilityF38' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientInabilityF38_No' name='rbClientInabilityF38' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>FAMILY/SOCIAL COMMENTS</span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtSocialComments' name='txtSocialComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4>PSYCHIATRIC STATUS</h4></center></p>

                <p className='w-750'><b>How many times have you been treated for any psychological or emotional problems:</b></p>

                <p className='w-750'><span className='eleHeader'><b>P1.</b>In a hospital or inpatient setting?</span>
                </p>
                <p className='w-100'> <input type='text' id='txtInpatientSetting' name='txtInpatientSetting' className='add-only' /> </p>

                <p className='w-750'><span className='eleHeader'><b>P2.</b>Outpatient/private patient?</span>
                    <span className='small'>{`Do not include substance abuse, employment, or family counseling. Treatment episode = a series of more or less continuous visits or treatment days, not the number of visits or treatment days. Enter diagnosis in comments if known.`}</span>
                </p>
                <p className='w-100'> <input type='text' id='txtOutpatientP2' name='txtOutpatientP2' className='add-only' /> </p>

                <p className='w-750'><span className='eleHeader'>P3. Do you receive a pension for a psychiatric disability? </span>
                    <input type='radio' id='rbPsychiatricDisability_Yes' name='rbPsychiatricDisability' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychiatricDisability_No' name='rbPsychiatricDisability' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>{`Have you had a significant period of time (that was not a direct result of drug/alcohol use) in which you have:`}</span>
                            <input type='radio' id='rbSignificantPeriod_Yes' name='rbSignificantPeriod' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSignificantPeriod_No' name='rbSignificantPeriod' className='add-only' value='No' /> No</td>
                        <td className='w-100'><span className='eleHeader'>Past 30 Days </span> </td>
                        <td className='w-100'><span className='eleHeader'>In Your Life</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P4.</b> </td>
                        <td className='w-500'>Experienced serious depression
                            <span className='small'>Sadness, hopelessness, loss of interest, difficulty with daily functioning</span> </td>
                        <td className='w-100'> <input type='text' id='txtHopelessness' name='txtHopelessness' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtHopelessness_1' name='txtHopelessness_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P5.</b> </td>
                        <td className='w-500'>Experienced serious anxiety or tension
                            <span className='small'>Uptight, unreasonably worried, inability to feel relaxed</span> </td>
                        <td className='w-100'> <input type='text' id='txtUptight' name='txtUptight' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtUptight_1' name='txtUptight_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P6.</b> </td>
                        <td className='w-500'>Experienced hallucinations
                            <span className='small'>Saw things/heard voices that others didn't see/hear</span> </td>
                        <td className='w-100'> <input type='text' id='txtHallucinations' name='txtHallucinations' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtHallucinations_1' name='txtHallucinations_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P7.</b> </td>
                        <td className='w-500'>Experienced trouble understanding,
                            concentrating or remembering</td>
                        <td className='w-100'> <input type='text' id='txtTrouble' name='txtTrouble' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtTrouble_1' name='txtTrouble_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P8.</b> </td>
                        <td className='w-500'> Experienced trouble controlling violent behavior including episodes or rage or txtViolence
                            <span className='small'>Patient can be under the influence of alcohol/drugs.</span></td>
                        <td className='w-100'> <input type='text' id='txtViolence' name='txtViolence' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtViolence_1' name='txtViolence_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P9.</b> </td>
                        <td className='w-500'> Experienced serious thoughts of suicide
                            <span className='small'>Patient seriously considered a plan for taking his/her life.
                             Patient can be under the influence of alcohol/drugs.</span></td>
                        <td className='w-100'> <input type='text' id='txtInfluence' name='txtInfluence' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtInfluence_1' name='txtInfluence_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P10.</b> </td>
                        <td className='w-500'>Attempted Suicide
                            <span className='small'>Include actual suicidal gestures or attempts. Patient can be under the influence of alcohol / drugs. </span></td>
                        <td className='w-100'> <input type='text' id='txtAttemptedSuicide' name='txtAttemptedSuicide' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAttemptedSuicide_1' name='txtAttemptedSuicide_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <b>P11.</b> </td>
                        <td className='w-500'> Been prescribed medication for any psychological or emotional problems
                            <span className='small'>Prescribed for the patient by a physician. Record "Yes" if a medication was prescribed even if the patient is not taking it. </span></td>
                        <td className='w-100'> <input type='text' id='txtEmotionalProblems' name='txtEmotionalProblems' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtEmotionalProblems_1' name='txtEmotionalProblems_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'><b>P12.</b> How many days in the past 30 have you experienced these psychological or emotional problems? </span>
                    <span className='small'>Refers to problems noted in Questions P4-P10. </span></p>
                <p className='w-100'> <input type='text' id='txtPsychological' name='txtPsychological' className='add-only' /> </p>

                <p className='w-750'><b>For Questions P13 & P14, ask the patient to use the Patient Rating Scale</b></p>

                <p className='w-750'> <span className='eleHeader'><b>P13.</b>How much have you been troubled or bothered by these psychological or emotional problems in the past 30 days?</span>
                    <span className='small'>Patient should be rating the problem days from Question P12.</span></p>
                <p className='w-100'> <input type='text' id='txtPatientP13' name='txtPatientP13' className='add-only' /> </p>

                <p className='w-750'> <span className='eleHeader'><b>P14.</b>How important to you now is treatment for these psychological problems? </span></p>
                <p className='w-100'> <input type='text' id='txtTreatmentP14' name='txtTreatmentP14' className='add-only' /> </p>

                <p className='w-750'><b>The following items are to be completed by the interviewer:</b></p>

                <p className='w-750'><span className='eleHeader'>{`At the time of the interview, the patient was:`}</span>
                    <input type='radio' id='rbInterview_Yes' name='rbInterview' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInterview_No' name='rbInterview' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-50'><b>P15.</b></td>
                        <td className='w-600'>Obviously depressed/withdrawn </td>
                        <td className='w-100'> <input type='text' id='txtDepressed' name='txtDepressed' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>P16.</b></td>
                        <td className='w-600'>Obviously hostile </td>
                        <td className='w-100'> <input type='text' id='txtHostile' name='txtHostile' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>P17.</b></td>
                        <td className='w-600'>Obviously anxious/nervous </td>
                        <td className='w-100'> <input type='text' id='txtNervous' name='txtNervous' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>P18.</b></td>
                        <td className='w-600'>Having trouble with reality testing, thought disorders, paranoid thinking </td>
                        <td className='w-100'> <input type='text' id='txtParanoidThinking' name='txtParanoidThinking' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>P19.</b></td>
                        <td className='w-600'>Having trouble comprehending, concentrating, remembering </td>
                        <td className='w-100'> <input type='text' id='txtConcentrating' name='txtConcentrating' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>P20.</b></td>
                        <td className='w-600'> Having suicidal thoughts </td>
                        <td className='w-100'> <input type='text' id='txtSuicidal' name='txtSuicidal' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>INTERVIEWER SEVERITY RATING</h4></center></p>

                <p className='w-750'> <span className='eleHeader'><b>P21.</b> How would you rate the patient's need for psychiatric/psychological treatment? </span></p>
                <p className='w-100'> <input type='text' id='txtPsychologicalP21' name='txtPsychologicalP21' className='add-only' /> </p>

                <p className='w-750'><center><h4>CONFIDENCE RATINGS</h4></center></p>

                <p className='w-750'><b>Is the above information significantly distorted by:</b></p>

                <p className='w-750'><span className='eleHeader'>P22. Client's misrepresentation?</span>
                    <input type='radio' id='rbClientMisrepresentationP22_Yes' name='rbClientMisrepresentationP22' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientMisrepresentationP22_No' name='rbClientMisrepresentationP22' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>P23. Client's inability to understand?</span>
                    <input type='radio' id='rbClientInabilityP23_Yes' name='rbClientInabilityP23' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientInabilityP23_No' name='rbClientInabilityP23' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PSYCHIATRIC STATUS COMMENTS </span>
                    <span className='small'>(Include the question number with your notes)</span>
                    <textarea id='txtPsychiatricStatus' name='txtPsychiatricStatus' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <b>SEVERITY PROFILE:</b> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Problems</span> </td>
                        <td className='w-50'> <span className='eleHeader'>0</span> </td>
                        <td className='w-50'> <span className='eleHeader'>1</span> </td>
                        <td className='w-50'> <span className='eleHeader'>2</span> </td>
                        <td className='w-50'> <span className='eleHeader'>3</span> </td>
                        <td className='w-50'> <span className='eleHeader'>4</span> </td>
                        <td className='w-50'> <span className='eleHeader'>5</span> </td>
                        <td className='w-50'> <span className='eleHeader'>6</span> </td>
                        <td className='w-50'> <span className='eleHeader'>7</span> </td>
                        <td className='w-50'> <span className='eleHeader'>8</span> </td>
                        <td className='w-50'> <span className='eleHeader'>9</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> MEDICAL</td>
                        <td className='w-50'> <input type='text' id='txtMedical' name='txtMedical' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_1' name='txtMedical_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_2' name='txtMedical_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_3' name='txtMedical_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_4' name='txtMedical_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_5' name='txtMedical_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_6' name='txtMedical_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_7' name='txtMedical_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_8' name='txtMedical_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtMedical_9' name='txtMedical_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> EMPL/SUP</td>
                        <td className='w-50'> <input type='text' id='txtEmpl' name='txtEmpl' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_1' name='txtEmpl_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_2' name='txtEmpl_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_3' name='txtEmpl_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_4' name='txtEmpl_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_5' name='txtEmpl_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_6' name='txtEmpl_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_7' name='txtEmpl_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_8' name='txtEmpl_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtEmpl_9' name='txtEmpl_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> ALCOHOL</td>
                        <td className='w-50'> <input type='text' id='txtAlcohol' name='txtAlcohol' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_1' name='txtAlcohol_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_2' name='txtAlcohol_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_3' name='txtAlcohol_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_4' name='txtAlcohol_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_5' name='txtAlcohol_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_6' name='txtAlcohol_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_7' name='txtAlcohol_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_8' name='txtAlcohol_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAlcohol_9' name='txtAlcohol_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> DRUG</td>
                        <td className='w-50'> <input type='text' id='txtDrug' name='txtDrug' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_1' name='txtDrug_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_2' name='txtDrug_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_3' name='txtDrug_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_4' name='txtDrug_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_5' name='txtDrug_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_6' name='txtDrug_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_7' name='txtDrug_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_8' name='txtDrug_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtDrug_9' name='txtDrug_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> LEGAL</td>
                        <td className='w-50'> <input type='text' id='txtLegal' name='txtLegal' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_1' name='txtLegal_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_2' name='txtLegal_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_3' name='txtLegal_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_4' name='txtLegal_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_5' name='txtLegal_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_6' name='txtLegal_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_7' name='txtLegal_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_8' name='txtLegal_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtLegal_9' name='txtLegal_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> FAM/SOC</td>
                        <td className='w-50'> <input type='text' id='txtFam' name='txtFam' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_1' name='txtFam_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_2' name='txtFam_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_3' name='txtFam_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_4' name='txtFam_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_5' name='txtFam_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_6' name='txtFam_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_7' name='txtFam_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_8' name='txtFam_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtFam_9' name='txtFam_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> PSYCH</td>
                        <td className='w-50'> <input type='text' id='txtPsych' name='txtPsych' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_1' name='txtPsych_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_2' name='txtPsych_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_3' name='txtPsych_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_4' name='txtPsych_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_5' name='txtPsych_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_6' name='txtPsych_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_7' name='txtPsych_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_8' name='txtPsych_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtPsych_9' name='txtPsych_9' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comprehensive Summary</span>
                    <textarea id='txtComprehensiveSummary' name='txtComprehensiveSummary' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Provider Signiture </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div >
        </form >
    )
}